import i18n from '@/lib/i18n';
import { Course } from '@/models/Course';
import CoursePath from '@/models/CoursePath';
import { translateDuration } from './courseDurationTranslation';
import { parseEnvNumberArray } from './env';

export function courseHasVersions(version: number, lastCourseVersion?: number) {
  return version > 1 || (!!lastCourseVersion && lastCourseVersion > 1);
}

export const displayCourseInformation = (
  course?: CoursePath['course'],
  lessonsQuantity?: CoursePath['lessonsQuantity'],
) => {
  const parts: string[] = [];

  if (course?.abbreviation) {
    parts.push(course.abbreviation.toUpperCase());
  }

  if (course?.duration) {
    parts.push(translateDuration(course.duration)?.toUpperCase());
  }

  if (lessonsQuantity) {
    parts.push(`${String(lessonsQuantity)} ${i18n.t('common.lessons')}`);
  }

  return parts.length > 0 ? parts.join(' - ') : '';
};

export function isExtraCourseEnabled(unitsIds: number[] = []) {
  const unitsEnabled = parseEnvNumberArray(
    process.env.VITE_EXTRA_COURSE_ENABLED,
  );

  return unitsEnabled.some(unitId => unitsIds?.includes(unitId));
}

export function getBannerImg(coursePath: CoursePath) {
  return coursePath?.course.bannerImg instanceof File
    ? URL.createObjectURL(coursePath?.course.bannerImg)
    : coursePath?.course.bannerImg || '/images/course-default-image.png';
}

export const adapterModuleCourse = <T extends Course | Partial<Course>>(
  course: T,
) => {
  const moduleId = course?.module?.id ?? 0;

  delete course.module;

  return {
    ...course,
    moduleId,
  };
};
